import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { shareReplay, tap, catchError } from 'rxjs/operators';
import { Constants } from '../models/constants';
import { of } from 'rxjs';
@Injectable({
    providedIn: 'root',
})
export class RolesService {
    constructor(private http: HttpClient) {}

    get(queryParams: any[]) {
        let params = new HttpParams();
        queryParams.forEach((param) => {
            params = params.set(param[0], param[1]);
        });
        const url = Constants.APP_BASE_API_URL + '/role/new';
        return this.http.get<any>(url, { params, responseType: 'json' });
    }

    getFilters() {
        const url = Constants.APP_BASE_API_URL + '/role/column-value';
        return this.http.get<any>(url, { responseType: 'json' });
    }

    getPermissions() {
        const url = Constants.APP_BASE_API_URL + '/role/default';
        return this.http.get<any>(url, { responseType: 'json' });
    }

    getRole() {
        const url = Constants.APP_BASE_API_URL + '/role/role-permissions';
        return this.http
            .get<any>(url, { responseType: 'json' })
            .pipe(shareReplay());
    }

    getPassPhrase(country,groupCode?:any) {
        if(groupCode == undefined){
            groupCode = ''
        }
        const url = Constants.APP_BASE_API_URL + '/entity/global?Country='+country+'&groupCode='+groupCode;
        return this.http
             .get<any>(url, {responseType: 'json'});

    }
    checkValidKSAUser(){
        const url = Constants.GATEWAY_BASE_API_URL + '/validateKSAUser';
        return this.http.get<any>(url, {responseType: 'json'});
    }

}
